import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant8PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 837 658",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M361.191 587.272C270.321 545.858 178.379 468.792 121.73 386.545C92.1551 343.567 71.6937 293.083 70.8449 240.902C69.2813 142.17 152.556 55.0076 255.221 73.3693C296.054 80.6514 327.238 107.859 343.991 145.163C364.944 191.849 346.806 243.494 363.916 290.716C381.384 338.876 435.888 365.949 487.131 365.413C538.374 364.877 586.668 342.137 630.942 316.404C675.215 290.671 718.014 261.14 766.577 244.789",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant8PathwayIllustration as default };
